import { __extends } from "tslib";
import { ImageBase } from '@awayjs/stage';
import { MaterialBase } from './MaterialBase';
import { ImageTexture2D } from './textures/ImageTexture2D';
/**
 * BasicMaterial forms an abstract base class for the default shaded materials provided by Stage,
 * using material methods to define their appearance.
 */
var BasicMaterial = /** @class */ (function (_super) {
    __extends(BasicMaterial, _super);
    function BasicMaterial(imageColor, alpha) {
        if (imageColor === void 0) { imageColor = null; }
        if (alpha === void 0) { alpha = 1; }
        var _this = _super.call(this, imageColor, alpha) || this;
        _this._preserveAlpha = false;
        //set a texture if an image is present
        if (imageColor instanceof ImageBase)
            _this.texture = new ImageTexture2D();
        return _this;
    }
    Object.defineProperty(BasicMaterial.prototype, "assetType", {
        /**
         *
         */
        get: function () {
            return BasicMaterial.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicMaterial.prototype, "preserveAlpha", {
        /**
         * Indicates whether alpha should be preserved - defaults to false
         */
        get: function () {
            return this._preserveAlpha;
        },
        set: function (value) {
            if (this._preserveAlpha == value)
                return;
            this._preserveAlpha = value;
            this.invalidate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicMaterial.prototype, "texture", {
        /**
         * The texture object to use for the albedo colour.
         */
        get: function () {
            return this._texture;
        },
        set: function (value) {
            if (this._texture == value)
                return;
            if (this._texture)
                this.removeTexture(this._texture);
            this._texture = value;
            if (this._texture)
                this.addTexture(this._texture);
        },
        enumerable: true,
        configurable: true
    });
    BasicMaterial.assetType = '[materials BasicMaterial]';
    return BasicMaterial;
}(MaterialBase));
export { BasicMaterial };
import { MaterialUtils, RenderGroup } from '@awayjs/renderer';
import { BlendMode } from '@awayjs/stage';
import { _Render_MaterialBase } from '@awayjs/renderer';
import { BasicMaterialPass } from './passes/BasicMaterialPass';
import { _Render_DepthMaterial, _Render_DistanceMaterial } from './MaterialBase';
/**
 * RenderMaterialObject forms an abstract base class for the default shaded materials provided by Stage,
 * using material methods to define their appearance.
 */
var _Render_BasicMaterial = /** @class */ (function (_super) {
    __extends(_Render_BasicMaterial, _super);
    function _Render_BasicMaterial(material, renderElements) {
        var _this = _super.call(this, material, renderElements) || this;
        _this._basicMaterial = material;
        _this._pAddPass(_this._pass = new BasicMaterialPass(_this, renderElements));
        return _this;
    }
    _Render_BasicMaterial.prototype.onClear = function (event) {
        _super.prototype.onClear.call(this, event);
        this._basicMaterial = null;
    };
    /**
     * @inheritDoc
     */
    _Render_BasicMaterial.prototype._pUpdateRender = function () {
        _super.prototype._pUpdateRender.call(this);
        this.requiresBlending = (this._basicMaterial.blendMode != BlendMode.NORMAL || this._basicMaterial.alphaBlending || (this._basicMaterial.colorTransform && this._basicMaterial.colorTransform.alphaMultiplier < 1));
        this._pass.preserveAlpha = this._basicMaterial.preserveAlpha; //this._pRequiresBlending;
        this._pass.shader.setBlendMode((this._basicMaterial.blendMode == BlendMode.NORMAL && this.requiresBlending) ? BlendMode.LAYER : this._basicMaterial.blendMode);
        //this._pass.forceSeparateMVP = false;
    };
    return _Render_BasicMaterial;
}(_Render_MaterialBase));
export { _Render_BasicMaterial };
RenderGroup.registerDefaultMaterial(_Render_BasicMaterial, BasicMaterial);
RenderGroup.registerDepthMaterial(_Render_DepthMaterial, BasicMaterial);
RenderGroup.registerDistanceMaterial(_Render_DistanceMaterial, BasicMaterial);
MaterialUtils.setDefaultMaterialClass(BasicMaterial);
